import axios from "axios";

export default {
  updateValidation(_id, validator, next, status, reason) {
    return axios({
      method: "patch",
      url: `${process.env.VUE_APP_API_URI}/validations/${_id}`,
      data: { validator, next, status, reason },
    });
  },
  getValidations() {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_URI}/validations`,
    });
  },
  getValidation(_id) {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_URI}/validations/${_id}`,
    });
  },
};
